/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserApplicationPreferencesDto } from '../../models/update-user-application-preferences-dto';
import { UpdateUserApplicationPreferencesResponse } from '../../models/update-user-application-preferences-response';

export interface UpdateUserApplicationPreferences$Params {
      body: UpdateUserApplicationPreferencesDto
}

export function updateUserApplicationPreferences(http: HttpClient, rootUrl: string, params: UpdateUserApplicationPreferences$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateUserApplicationPreferencesResponse>> {
  const rb = new RequestBuilder(rootUrl, updateUserApplicationPreferences.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateUserApplicationPreferencesResponse>;
    })
  );
}

updateUserApplicationPreferences.PATH = '/api/v1/session/application-preferences';
